import Typography, { TypographyProps } from '@mui/material/Typography';
import { DateFieldProps, useRecordContext } from 'react-admin';
import { NEW_YORK_TIMEZONE } from '../forms/form-utils';

export const estDateTimeFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h12',
  timeZone: NEW_YORK_TIMEZONE,
};

const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})$/;

const getRecordValue = (record: Record<string, any> | undefined, source: string) =>
  source
    .split('.')
    .reduce<unknown>((value, key) => (value == null ? undefined : (value as Record<string, any>)[key]), record);

export const formatESTDateFieldValue = (value: unknown, emptyText = '') => {
  if (value === null || value === undefined || value === '') return emptyText;

  if (typeof value === 'string') {
    const dateOnlyMatch = dateOnlyPattern.exec(value);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return `${month}/${day}/${year}`;
    }
  }

  const date = value instanceof Date ? value : new Date(value as string | number);
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat('en-US', estDateTimeFormatOptions).format(date);
};

export const ESTDateField = (props: DateFieldProps & { variant?: TypographyProps['variant'] }) => {
  const { emptyText, source, variant = 'body2' } = props;
  const record = useRecordContext(props);
  const value = source ? getRecordValue(record, source) : undefined;

  return (
    <Typography component="span" variant={variant} sx={{ textWrap: 'nowrap' }}>
      {formatESTDateFieldValue(value, emptyText)}
    </Typography>
  );
};
